
import { Vue, Prop, Watch } from "vue-property-decorator";
import ListViewItem from "tirscript3-list-view/src/ListViewItem";

export default class UiDropdownComponent extends Vue {
  @Prop({ default: () => [], type: Array }) items!: ListViewItem<any>[];
  @Prop({ default: false, type: Boolean }) multiselect: Boolean;
  @Prop({ default: "...", type: String }) placeholder!: String;
  @Prop({ default: false, type: Boolean }) disabled: boolean;
  @Prop({ default: false, type: Boolean }) transformer: boolean;
  @Prop({ default: "tirscript-icon-ic_down", type: String }) icon: string;

  @Prop({ default: false, type: Boolean }) removeSelected: boolean;

  @Prop({ default: false, type: Boolean }) underline: boolean;
  @Prop({ default: false, type: Boolean }) scroll: boolean;
  @Prop({ default: null, type: String }) countItem: String;

  @Prop({ default: "", type: String }) autocompleteText: String;
  @Prop({ default: false, type: Boolean }) autocomplete: boolean;
  @Prop({ default: "", type: String }) height: String;

  @Prop({ default: false, type: Boolean }) autoOpen: boolean;
  @Prop({ default: false }) required: boolean;
  eShowItemsList = false;
  get ShowItemsList(): boolean {
    return this.eShowItemsList;
  }
  set ShowItemsList(value: boolean) {
    if (!value) {
    }
    this.$forceUpdate();
    this.eShowItemsList = value;
  }
  hasError = false;
  autoComplete = "";
  focusOn = false;
  ItemsInner: ListViewItem<{ id: number; name: string }>[] = this.items; //(this.items).map(x => Object.assign({}, x));
  innerIcon = "";
  innerTransformer = false;
  filter: String = "";
  outside = false;
  h = 0; // высота для скролла
  styleUiSelect: Object;

  @Watch("autocompleteText")
  onChangeautocomplete() {
    if (this.autocomplete) {
      this.autoComplete = this.autocompleteText.toString();
      this.$emit("changeAutocomlite", this.autoComplete);
    }
  }

  @Watch("items")
  onItemsChanged(items: ListViewItem<any>[]) {
    this.ItemsInner = this.items;
  }

  @Watch("autoOpen")
  onAutoOpen() {
    this.ShowItemsList = true;
  }

  created() {
    this.innerIcon = this.icon;
    this.innerTransformer = this.transformer;
  }
  mounted() {
    const x = this.$refs.dropdown;

    this.ItemsInner = this.items;
    this.styleUiSelect = {
      height: this.height,
    };
    document.body.addEventListener("click", this.clickOutside.bind(this));
    this.ShowItemsList = this.autoOpen;
  }
  isValid(): boolean {
    if (this.required && !(this.getSelectItems().length > 0)) {
      this.hasError = true;
      return false;
    }
    return true;
  }

  onSelect(value: any) {
    if (this.multiselect) {
      this.ShowItemsList = false;
    }

    var items = this.getSelectItems();

    if (!this.multiselect && items.length > 1) {
      console.error("Больше одного выбранного элемента, установите multiselect в true.");
    }
    this.$emit("change", items);
  }

  onClick() {
    if (this.disabled) {
      return;
    }
    this.ShowItemsList = !this.ShowItemsList;

    this.innerTransformer = false;
    // (this.$refs.auto as any).focus();
    this.$emit("click", this.ShowItemsList);
    return false;
  }

  onClose(value: any) {
    value.Selected = false;
    if (this.multiselect) this.ShowItemsList = true;
    this.$emit("deleteItem", value);
  }

  onChange() {}
  onInputAutocomplete(res: string[]) {
    this.$emit("changeAutocomlite", this.autoComplete);
  }

  onEnterAutocomplete() {
    if (this.ItemsInner[0] != null) {
      this.selectItem(this.ItemsInner[0]);
      var items = this.getSelectItems();
      this.$emit(
        "change",
        this.ItemsInner.filter((el) => el.Selected)
      );
    }
    // this.autoComplete = '';
    this.filter = "";
    this.ShowItemsList = false;
  }

  selectItem(value: any) {
    if (!this.multiselect) {
      this.ItemsInner.forEach(
        (x) => (x.Selected = x.Value.Equal(value.Value)) // x.Value.id == value.Value.id)
      );
    } else {
      this.ItemsInner[this.ItemsInner.indexOf(value)].Selected = true;
    }
  }

  getInnerItems(): Array<ListViewItem<any>> {
    // debugger;
    // расчет высоты выпадающего окна в случае включенного scroll
    // const x= this.$refs.dropdown;

    const fontSize = 30;
    if (!this.countItem) {
      this.h =
        this.ItemsInner.length * fontSize > 200 ? 200 : this.ItemsInner.length * fontSize;
    } else {
      this.h = Number(this.countItem) * fontSize;
    }
    if (!this.removeSelected) {
      if (this.filter != "" && this.filter != null) {
        const rez = this.ItemsInner.filter(
          (x) => x.Value.ToString().toLowerCase().indexOf(this.filter.toLowerCase()) > -1
          // x.Value.Name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        );

        return rez;
      } else {
        // this.h = this.ItemsInner.length * 25 > 400 ? 400 : this.ItemsInner.length * 35;
        // console.log('h=', this.ItemsInner.length);
        return this.ItemsInner;
      }
    } else {
      let rez = this.ItemsInner.filter((item) => !item.Selected);
      // this.h = this.ItemsInner.length * 25 > 400 ? 400 : this.ItemsInner.length * 35;
      // console.log('h=', this.ItemsInner.length);
      return rez;
    }
  }

  getStyle(el, styleProp) {
    var camelize = function (str) {
      return str.replace(/\-(\w)/g, function (str, letter) {
        return letter.toUpperCase();
      });
    };

    if (el.currentStyle) {
      return el.currentStyle[camelize(styleProp)];
    } else if (document.defaultView && document.defaultView.getComputedStyle) {
      return document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    } else {
      return el.style[camelize(styleProp)];
    }
  }
  getSelectItems(): Array<ListViewItem<any>> {
    let res = this.ItemsInner.filter((item) => item.Selected) || [];
    return res;
  }

  getSelectText(): String {
    if (this.getSelectItems().length > 0) {
      this.innerTransformer = this.transformer;
      return this.getSelectItems()[0].Value.ToString();
    }
    return "";
  }

  onFocus() {
    // this.ShowItemsList = true;
  }
  onKeypress(value: any) {
    // if (this.focusOn) {
    //   this.ShowItemsList = false;
    //   this.focusOn = false;
    // } else {
    //   this.focusOn = true;
    // }
  }

  onKeyUp() {
    // console.log("onKeyUp" + this.focusOn);
  }
  onMouseLeave() {
    this.outside = true;
  }
  onMouseOver() {
    this.outside = false;
  }
  clickOutside(event: any) {
    if (!(this.$el == event.target || this.$el.contains(event.target))) {
      this.innerTransformer = this.transformer;
      if (this.ShowItemsList && this.outside) this.ShowItemsList = false;
      this.$emit("clickOutSide");
    }
  }

  destroyed() {
    document.body.removeEventListener("click", this.clickOutside.bind(this));
  }
}
